import { HorizontalCardGroup, Icon } from '@ps/isp-web-component-library';
import { Flame } from '@ps/isp-web-component-library/icons/Flame';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import type { SportsHomePageWidgetModel } from 'widgets/sports-home-page-widget/model';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { ExtractSelectFromModel, RootState } from '@swf/core/store';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';

import { TXTWCL_Popular_Bet_Builders } from './PopularBetBuilders.messages.json';
import styles from './PopularBetBuilders.scss';
import PopularBetBuilderCard from './components/PopularBetBuilderCard/PopularBetBuilderCard';
import bgImage from './widget-bg.png';

interface Props {
  widgetSelect: Pick<
    ExtractSelectFromModel<SportsHomePageWidgetModel>,
    'hasPopularBetBuilders' | 'popularBetBuilders'
  >;
  isEventPage?: true;
}

export const PopularBetBuilders: React.FC<Props> = ({ widgetSelect, isEventPage }) => {
  const hasPopularBetBuilders = useSelector((state: RootState) =>
    widgetSelect.hasPopularBetBuilders(state)
  );

  const popularBetBuilders = useSelector((state: RootState) =>
    widgetSelect.popularBetBuilders(state)
  );
  const { formatMessage } = useRegulatoryIntl();

  if (!hasPopularBetBuilders) return null;
  return (
    <SportsComponent name="Sports Popular Bet Builders Component">
      <div className={styles.panel}>
        <header className={styles.panelHeader}>
          <Icon size="xl" icon={Flame} label={formatMessage(TXTWCL_Popular_Bet_Builders)} />
          <span>
            <Translation {...TXTWCL_Popular_Bet_Builders} />
          </span>
        </header>
        <HorizontalCardGroup
          className={styles.horizontalCardGroup}
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          {popularBetBuilders.map((popularBetBuilder) => (
            <PopularBetBuilderCard
              key={popularBetBuilder.runnersIds.map(({ selectionId }) => selectionId).join('-')}
              popularBetBuilder={popularBetBuilder}
              isEventPage={isEventPage}
            />
          ))}
        </HorizontalCardGroup>
      </div>
    </SportsComponent>
  );
};
